const DocMenuConfig = [
  {
    heading: 'Reports & Analytics',
    route: '',
    ability: {
      method: 'read',
      resource: ['dashboard', 'reports'],
    },
    pages: [
      {
        heading: 'Dashboard',
        route: '/dashboard2',
        svgIcon: '/media/icons/duotune/art/art002.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'dashboard',
        },
      },
      {
        heading: 'Dashboard - 1.0',
        route: '/dashboard',
        svgIcon: '/media/icons/duotune/art/art002.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'dashboard',
        },
      },
      {
        heading: 'Audit Logs',
        route: '/audit-logs',
        svgIcon: '/media/icons/duotune/general/gen055.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'audit',
        },
      },
      {
        sectionTitle: 'Reports',
        route: '/reports',
        svgIcon: '/media/icons/duotune/general/gen055.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'reports',
        },
        sub: [
          {
            heading: 'Registered Trades Reports',
            route: '/manage/reports/reports-registered-trades',
            ability: {
              method: 'read',
              resource: 'reports',
            },
          },
          {
            heading: 'Ads Quarter Reports',
            route: '/manage/reports/reports-ads-quarter',
            ability: {
              method: 'read',
              resource: 'reports',
            },
          },
          {
            heading: 'Registered Trades Top Reports',
            route: '/manage/reports/top-reports-registered-trades',
            ability: {
              method: 'read',
              resource: 'reports',
            },
          },
          {
            heading: 'Registered Trades Quarter Reports',
            route: '/manage/reports/reports-registered-trades-quarter',
            ability: {
              method: 'read',
              resource: 'reports',
            },
          },
          {
            heading: 'Registered Trades Areas Reports',
            route: '/manage/reports/reports-registered-trades-areas',
            ability: {
              method: 'read',
              resource: 'reports',
            },
          },
          {
            heading: 'Registered Trades Gov Totals Reports',
            route: '/manage/reports/reports-registered-trades-totals',
            ability: {
              method: 'read',
              resource: 'reports',
            },
          },
          {
            heading: 'auctionsReport',
            route: '/manage/reports/auctions-report',
            ability: {
              method: 'read',
              resource: 'reports',
            },
          },
          {
            heading: 'auctionPropertiesReport',
            route: '/manage/reports/auction-properties-report',
            ability: {
              method: 'read',
              resource: 'reports',
            },
          },
          {
            heading: 'activeAdsSummaryReport',
            route: '/manage/reports/active-ads-summary-report',
            ability: {
              method: 'read',
              resource: 'reports',
            },
          },
        ],
      },
    ],
  },
  {
    heading: 'User Management',
    route: '',
    ability: {
      method: 'read',
      resource: [
        'admins',
        'users',
        'official-appraisal',
        'own-appraiser',
        'banks',
        'roles',
        'assets',
      ],
    },
    pages: [
      {
        sectionTitle: 'Users Lists',
        route: '/members',
        svgIcon: '/media/icons/duotune/general/gen055.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: [
            'admins',
            'users',
            'official-appraisal',
            'own-appraiser',
            'banks',
          ],
        },
        sub: [
          {
            heading: 'Admins',
            route: '/manage/members/admins-listing',
            ability: {
              method: 'read',
              resource: 'admins',
            },
          },
          {
            heading: 'Regular Users',
            route: '/manage/members/users-listing',
            ability: {
              method: 'read',
              resource: 'users',
            },
          },
          {
            heading: 'Broker Offices',
            route: '/manage/members/offices-listing',
            ability: {
              method: 'read',
              resource: 'users',
            },
          },
          {
            heading: 'Appraisers',
            route: '/manage/members/appraisers-listing',
            ability: {
              method: 'read',
              resource: ['official-appraisal', 'own-appraiser'],
            },
          },
          {
            heading: 'Banks Staff',
            route: '/manage/members/banks-listing',
            ability: {
              method: 'read',
              resource: 'banks',
            },
          },
        ],
      },
      {
        sectionTitle: 'Users Settings',
        route: '/members-settings',
        svgIcon: '/media/icons/duotune/general/gen055.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: ['admins', 'users', 'roles', 'assets'],
        },
        sub: [
          {
            heading: 'Generate OTP',
            route: '/manage/members-settings/generate-otp',
            ability: {
              method: 'create',
              resource: 'users',
            },
          },
          {
            heading: 'Roles & Permission',
            route: '/manage/members-settings/roles-listing',
            ability: {
              method: 'read',
              resource: 'roles',
            },
          },
          {
            heading: 'Registration Reasons',
            route: '/manage/members-settings/registration-reasons-listing',
            ability: {
              method: 'read',
              resource: 'assets',
            },
          },
        ],
      },
    ],
  },
  {
    heading: 'Hisba Lists',
    route: '',
    ability: {
      method: 'read',
      resource: ['ads', 'auctions', 'registered-trades'],
    },
    pages: [
      {
        sectionTitle: 'Listing Ads',
        route: '/ads',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'ads',
        },
        sub: [
          {
            heading: 'Ads List',
            route: '/manage/ads/ads-listing',
            ability: {
              method: 'read',
              resource: 'ads',
            },
          },
          {
            heading: 'Ads Types',
            route: '/manage/ads/ad-types-listing',
            ability: {
              method: 'read',
              resource: 'ads',
            },
          },
          {
            heading: 'Property Type',
            route: '/manage/ads/property-types-listing',
            ability: {
              method: 'read',
              resource: 'assets',
            },
          },
          {
            heading: 'Ads Types - Sectors',
            route: '/manage/ads/property-categories-listing',
            ability: {
              method: 'read',
              resource: 'ads',
            },
          },
          {
            heading: 'Property Types Grouping',
            route: '/manage/ads/ads-property-grouping-listing',
            ability: {
              method: 'read',
              resource: 'ads',
            },
          },
        ],
      },
      {
        sectionTitle: 'Brokerage Ad Management',
        route: '/ads-brokerage',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'ads',
        },
        sub: [
          {
            heading: 'General Configuration',
            route: '/manage/ads-brokerage/ads-brokerage-configuration-listing',
            ability: {
              method: 'read',
              resource: 'ads',
            },
          },
          {
            heading: 'Area Configuration',
            route: '/manage/ads-brokerage/ads-brokerage-listing',
            ability: {
              method: 'read',
              resource: 'ads',
            },
          },
        ],
      },
      {
        sectionTitle: 'Auctions',
        route: '/auctions',
        svgIcon: '/media/icons/duotune/finance/fin003.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'auctions',
        },
        sub: [
          {
            heading: 'Auction Events',
            route: '/manage/auctions/auctions-listing',
            ability: {
              method: 'read',
              resource: 'auctions',
            },
          },
          {
            heading: 'Properties',
            route:
              '/manage/auctions/auctions-properties/auctions-properties-listing',
            ability: {
              method: 'read',
              resource: 'auctions',
            },
          },
          {
            heading: 'Property Types',
            route: '/manage/auctions/property-types-listing',
            ability: {
              method: 'read',
              resource: 'auctions',
            },
          },
          {
            heading: 'Organizers',
            route: '/manage/auctions/organizers-listing',
            ability: {
              method: 'read',
              resource: 'auctions',
            },
          },
          {
            heading: 'Organizers Locations',
            route: '/manage/auctions/locations-listing',
            ability: {
              method: 'read',
              resource: 'auctions',
            },
          },
          {
            heading: 'Auctions Locations',
            route:
              '/manage/auctions/auctions-locations/auctions-locations-listing',
            ability: {
              method: 'read',
              resource: 'auctions',
            },
          },
          {
            heading: 'Auctions Descriptions',
            route:
              '/manage/auctions/auctions-descriptions/auctions-descriptions-listing',
            ability: {
              method: 'read',
              resource: 'auctions',
            },
          },
          {
            heading: 'Auctions Status',
            route: '/manage/auctions/auctions-status/auctions-status-listing',
            ability: {
              method: 'read',
              resource: 'auctions',
            },
          },
          {
            heading: 'Auctions Property Groupings',
            route:
              '/manage/auctions/auctions-property-grouping/auctions-property-grouping-listing',
            ability: {
              method: 'read',
              resource: 'auctions',
            },
          },
        ],
      },
      {
        sectionTitle: 'Trades',
        route: '/registered-trades',
        svgIcon: '/media/icons/duotune/general/gen055.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'registered-trades',
        },
        sub: [
          {
            heading: 'Trades List',
            route: '/manage/registered-trades/registered-trades-listing',
            ability: {
              method: 'read',
              resource: 'registered-trades',
            },
          },
          {
            heading: 'MOJ Feed',
            route:
              '/manage/registered-trades/registered-trades-scraping-listing',
            ability: {
              method: 'read',
              resource: 'registered-trades',
            },
          },
          {
            heading: 'Trades Sectors',
            route:
              '/manage/registered-trades/registered-trades-grouping-listing',
            ability: {
              method: 'read',
              resource: 'registered-trades',
            },
          },
          {
            heading: 'Property Descriptions',
            route: '/manage/registered-trades/property-descriptions-listing',
            ability: {
              method: 'read',
              resource: 'assets',
            },
          },
        ],
      },
    ],
  },
  {
    heading: 'Hisba Tools',
    route: '',
    ability: {
      method: 'read',
      resource: [
        'cce',
        'instant-rent-estimator',
        'ive',
        'loan-calculator',
        'admin-banks-rates',
      ],
    },
    pages: [
      {
        sectionTitle: 'Hisba Realty',
        route: '/ive',
        svgIcon: '/media/icons/duotune/finance/fin003.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'ive',
        },
        sub: [
          {
            heading: 'About (Mobile)',
            route: '/manage/ive/about-overview',
            ability: {
              method: 'read',
              resource: 'ive',
            },
          },
          {
            heading: 'About (Web)',
            route: '/manage/ive/about-overview-web',
            ability: {
              method: 'read',
              resource: 'ive',
            },
          },
          {
            heading: 'Areas',
            route: '/manage/ive/area/areas-listing',
            ability: {
              method: 'read',
              resource: 'ive',
            },
          },
          {
            heading: 'Estimator',
            route: '/manage/ive/estimator/land-listing',
            ability: {
              method: 'read',
              resource: 'ive',
            },
          },
          {
            sectionTitle: 'Land Factor Options',
            route: '/manage/ive/factor-options',
            ability: {
              method: 'read',
              resource: 'ive',
            },
            sub: [
              {
                heading: 'Land Size',
                route: '/manage/ive/factor-options/land-size-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Street',
                route: '/manage/ive/factor-options/street-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Location',
                route: '/manage/ive/factor-options/location-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Location Specs',
                route: '/manage/ive/factor-options/location-specs-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Facing Specs',
                route: '/manage/ive/factor-options/facing-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Curb',
                route: '/manage/ive/factor-options/curb-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Plot Specs',
                route: '/manage/ive/factor-options/plot-specs-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Direction',
                route: '/manage/ive/factor-options/direction-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Sabah City',
                route: '/manage/ive/factor-options/sabah-city-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
            ],
          },
          {
            sectionTitle: 'Building Factor Options',
            route: '/manage/ive/building-factor-options',
            ability: {
              method: 'read',
              resource: 'ive',
            },
            sub: [
              {
                heading: 'Building Age',
                route:
                  '/manage/ive/building-factor-options/building-age-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Number Of Floors',
                route: '/manage/ive/building-factor-options/floors-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Finishing Quality',
                route: '/manage/ive/building-factor-options/fq-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
            ],
          },
          {
            sectionTitle: 'Other',
            route: '/other',
            ability: {
              method: 'read',
              resource: 'ive',
            },
            sub: [
              {
                heading: 'Sea Front Lengths',
                route: '/manage/ive/other/sea-front-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Back Street Lengths',
                route: '/manage/ive/other/back-street-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
            ],
          },
          {
            sectionTitle: 'Finishing Quality',
            route: '/finishing-quality',
            ability: {
              method: 'read',
              resource: 'ive',
            },
            sub: [
              {
                heading: 'Quality Ranges',
                route:
                  '/manage/ive/finishing-quality/ranges/quality-ranges-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
              {
                heading: 'Quality Groups',
                route:
                  '/manage/ive/finishing-quality/groups/quality-groups-listing',
                ability: {
                  method: 'read',
                  resource: 'ive',
                },
              },
            ],
          },
        ],
      },
      {
        sectionTitle: 'Hisba Rent',
        route: '/ire',
        svgIcon: '/media/icons/duotune/finance/fin003.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'instant-rent-estimator',
        },
        pages: [
          {
            sectionTitle: 'Residential',
            route: '/ire/ire-v2',
            svgIcon: '/media/icons/duotune/finance/fin003.svg',
            fontIcon: 'bi-sticky',
            ability: {
              method: 'read',
              resource: 'instant-rent-estimator',
            },
            sub: [
              {
                heading: 'About (Mobile)',
                route: '/manage/ire/ire-v2/about-overview',
                ability: {
                  method: 'read',
                  resource: 'settings',
                },
              },
              {
                heading: 'About (Web)',
                route: '/manage/ire/ire-v2/about-overview-web',
                ability: {
                  method: 'read',
                  resource: 'settings',
                },
              },
              {
                heading: 'Areas',
                route: '/manage/ire/ire-v2/areas-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                sectionTitle: 'Factors',
                route: '/ire-factors',
                svgIcon: '/media/icons/duotune/technology/teh005.svg',
                fontIcon: 'bi-sticky',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
                sub: [
                  {
                    heading: 'Property Type',
                    route:
                      '/manage/ire/ire-v2/ire-factors/property-type-listing',
                    ability: {
                      method: 'read',
                      resource: 'instant-rent-estimator',
                    },
                  },
                  {
                    heading: 'Floor Type',
                    route: '/manage/ire/ire-v2/ire-factors/floor-type-listing',
                    ability: {
                      method: 'read',
                      resource: 'instant-rent-estimator',
                    },
                  },
                  {
                    heading: 'Property Age',
                    route:
                      '/manage/ire/ire-v2/ire-factors/property-age-listing',
                    ability: {
                      method: 'read',
                      resource: 'instant-rent-estimator',
                    },
                  },
                ],
              },
            ],
          },
          {
            sectionTitle: 'Investment',
            route: '/ire-investment',
            svgIcon: '/media/icons/duotune/finance/fin003.svg',
            fontIcon: 'bi-sticky',
            ability: {
              method: 'read',
              resource: 'instant-rent-estimator',
            },
            sub: [
              {
                heading: 'About',
                route: '/manage/ire/ire-investment/about-overview',
                ability: {
                  method: 'read',
                  resource: 'settings',
                },
              },
              {
                heading: 'Areas',
                route: '/manage/ire/ire-investment/areas-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'config',
                route: '/manage/ire/ire-investment/config-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Property Type',
                route: '/manage/ire/ire-investment/property-type-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Property Age',
                route: '/manage/ire/ire-investment/property-age-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Locations',
                route: '/manage/ire/ire-investment/locations-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                sectionTitle: 'Investment Factors',
                route: '/manage/ire/ire-investment/factors',
                svgIcon: '/media/icons/duotune/technology/teh005.svg',
                fontIcon: 'bi-sticky',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
                sub: [
                  {
                    heading: 'Property Services',
                    route:
                      '/manage/ire/ire-investment/factors/factors-property-services-listing',
                    ability: {
                      method: 'read',
                      resource: 'instant-rent-estimator',
                    },
                  },
                  {
                    heading: 'Location specs',
                    route:
                      '/manage/ire/ire-investment/factors/factors-location-specs-listing',
                    ability: {
                      method: 'read',
                      resource: 'instant-rent-estimator',
                    },
                  },
                  {
                    heading: 'Electricity',
                    route:
                      '/manage/ire/ire-investment/factors/factors-electricity-specs-listing',
                    ability: {
                      method: 'read',
                      resource: 'instant-rent-estimator',
                    },
                  },
                ],
              },
            ],
          },

          {
            sectionTitle: 'Crafts',
            route: '/ire-literal',
            svgIcon: '/media/icons/duotune/finance/fin003.svg',
            fontIcon: 'bi-sticky',
            ability: {
              method: 'read',
              resource: 'instant-rent-estimator',
            },
            sub: [
              {
                heading: 'Areas',
                route: '/manage/ire/ire-literal/areas-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Streets',
                route: '/manage/ire/ire-literal/street-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Property Type',
                route: '/manage/ire/ire-literal/property-type-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Floor Type',
                route: '/manage/ire/ire-literal/floor-type-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Direction',
                route: '/manage/ire/ire-literal/direction-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Property Age',
                route: '/manage/ire/ire-literal/property-age-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Quality',
                route: '/manage/ire/ire-literal/quality-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                sectionTitle: 'literal Factors',
                route: '/manage/ire/ire-literal/factors',
                svgIcon: '/media/icons/duotune/technology/teh005.svg',
                fontIcon: 'bi-sticky',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
                sub: [
                  {
                    heading: 'Property Services',
                    route:
                      '/manage/ire/ire-literal/factors/factors-property-services-listing',
                    ability: {
                      method: 'read',
                      resource: 'instant-rent-estimator',
                    },
                  },
                ],
              },
            ],
          },
          {
            sectionTitle: 'Commercial',
            route: '/ire-commercial',
            svgIcon: '/media/icons/duotune/finance/fin003.svg',
            fontIcon: 'bi-sticky',
            ability: {
              method: 'read',
              resource: 'instant-rent-estimator',
            },
            sub: [
              {
                heading: 'Areas',
                route: '/manage/ire/ire-commercial/areas-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Streets',
                route: '/manage/ire/ire-commercial/street-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Property Type',
                route: '/manage/ire/ire-commercial/property-type-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Floor Type',
                route: '/manage/ire/ire-commercial/floor-type-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Direction',
                route: '/manage/ire/ire-commercial/direction-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Property Age',
                route: '/manage/ire/ire-commercial/property-age-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Quality',
                route: '/manage/ire/ire-commercial/quality-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                sectionTitle: 'commercial Factors',
                route: '/manage/ire/ire-commercial/factors',
                svgIcon: '/media/icons/duotune/technology/teh005.svg',
                fontIcon: 'bi-sticky',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
                sub: [
                  {
                    heading: 'Property Services',
                    route:
                      '/manage/ire/ire-commercial/factors/factors-property-services-listing',
                    ability: {
                      method: 'read',
                      resource: 'instant-rent-estimator',
                    },
                  },
                ],
              },
            ],
          },
          {
            sectionTitle: 'Industrial',
            route: '/ire-industrial',
            svgIcon: '/media/icons/duotune/finance/fin003.svg',
            fontIcon: 'bi-sticky',
            ability: {
              method: 'read',
              resource: 'instant-rent-estimator',
            },
            sub: [
              {
                heading: 'Areas',
                route: '/manage/ire/ire-industrial/areas-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Streets',
                route: '/manage/ire/ire-industrial/street-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Property Type',
                route: '/manage/ire/ire-industrial/property-type-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Floor Type',
                route: '/manage/ire/ire-industrial/floor-type-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Direction',
                route: '/manage/ire/ire-industrial/direction-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Property Age',
                route: '/manage/ire/ire-industrial/property-age-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                heading: 'Quality',
                route: '/manage/ire/ire-industrial/quality-listing',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
              },
              {
                sectionTitle: 'industrial Factors',
                route: '/manage/ire/ire-industrial/factors',
                svgIcon: '/media/icons/duotune/technology/teh005.svg',
                fontIcon: 'bi-sticky',
                ability: {
                  method: 'read',
                  resource: 'instant-rent-estimator',
                },
                sub: [
                  {
                    heading: 'Property Services',
                    route:
                      '/manage/ire/ire-industrial/factors/factors-property-services-listing',
                    ability: {
                      method: 'read',
                      resource: 'instant-rent-estimator',
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        sectionTitle: 'Hisba Build',
        route: '/cce',
        svgIcon: '/media/icons/duotune/technology/teh005.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'cce',
        },
        sub: [
          {
            heading: 'About (Mobile)',
            route: '/manage/cce/about-overview',
            ability: {
              method: 'read',
              resource: 'cce',
            },
          },
          {
            heading: 'About (Web)',
            route: '/manage/cce/about-overview-web',
            ability: {
              method: 'read',
              resource: 'cce',
            },
          },
          {
            heading: 'Groups',
            route: '/manage/cce/cce-groups-listing',
            ability: {
              method: 'read',
              resource: 'cce',
            },
          },
          {
            heading: 'Categories',
            route: '/manage/cce/cce-categories-listing',
            ability: {
              method: 'read',
              resource: 'cce',
            },
          },
          {
            heading: 'Sub Categories',
            route: '/manage/cce/cce-sub-categories-listing',
            ability: {
              method: 'read',
              resource: 'cce',
            },
          },
        ],
      },
      {
        sectionTitle: 'Hisba Fund',
        route: '/banks',
        svgIcon: '/media/icons/duotune/general/gen055.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'admin-banks-rates',
        },
        sub: [
          {
            heading: 'Bank Rates',
            route: '/manage/banks/admin-bank-rates-listing',
            ability: {
              method: 'read',
              resource: 'admin-banks-rates',
            },
          },
          {
            heading: 'Loan Calculator Privacy (Mobile)',
            route: '/manage/banks/loan-calculator-about-overview',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Loan Calculator Privacy (Web)',
            route: '/manage/banks/loan-calculator-about-overview-web',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
        ],
      },
    ],
  },
  {
    heading: 'Other Services',
    route: '',
    ability: {
      method: 'read',
      resource: ['loan-calculator', 'official-appraisal', 'appraisal-request'],
    },
    pages: [
      {
        sectionTitle: 'Official Appraisals',
        route: '/appraisals',
        svgIcon: '/media/icons/duotune/finance/fin007.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'official-appraisal',
        },
        sub: [
          {
            heading: 'About (Mobile)',
            route: '/manage/appraisals/about-overview',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'About (Web)',
            route: '/manage/appraisals/about-overview-web',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Property Type',
            route: '/manage/appraisals/properties-listing',
            ability: {
              method: 'read',
              resource: 'official-appraisal',
            },
          },
          {
            heading: 'Appraisals Requests',
            route: '/manage/appraisals/appraisals-listing',
            ability: {
              method: 'read',
              resource: 'official-appraisal',
            },
          },
          {
            heading: 'Requests',
            route: '/manage/appraisals/appraiser-appraisals-listing',
            ability: {
              method: 'read',
              resource: 'appraisal-request',
            },
          },
        ],
      },
      {
        sectionTitle: 'Real Estate Funds',
        route: '/finance-request',
        svgIcon: '/media/icons/duotune/finance/fin007.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'loan-calculator',
        },
        sub: [
          {
            heading: 'About (Mobile)',
            route: '/manage/finance-request/about-overview',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'About (Web)',
            route: '/manage/finance-request/about-overview-web',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Funds Request',
            route: '/manage/finance-request/finance-funds-request-listing',
            svgIcon: '/media/icons/duotune/finance/fin007.svg',
            fontIcon: 'bi-sticky',
            ability: {
              method: 'read',
              resource: 'loan-calculator',
            },
          },
        ],
      },
    ],
  },
  {
    heading: 'Hisba Transaction',
    route: '',
    ability: {
      method: 'read',
      resource: 'payments',
    },
    pages: [
      {
        heading: 'Promotions',
        route: '/manage/subscriptions/promotions-listing',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        ability: {
          method: 'read',
          resource: 'payments',
        },
      },
      {
        heading: 'Packages',
        route: '/manage/subscriptions/packages-listing',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        ability: {
          method: 'read',
          resource: 'payments',
        },
      },
      {
        heading: 'Payment Logs',
        route: '/manage/subscriptions/payment-logs-listing',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        ability: {
          method: 'read',
          resource: 'payments',
        },
      },
      {
        heading: 'Subscriptions',
        route: '/manage/subscriptions/purchase-logs-listing',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        ability: {
          method: 'read',
          resource: 'payments',
        },
      },
    ],
  },

  {
    heading: 'Settings',
    route: '',
    ability: {
      method: 'read',
      resource: 'settings',
    },
    pages: [
      {
        heading: 'Home Services',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        fontIcon: 'bi-sticky',
        route: '/manage/assets/home-services-listing',
        ability: {
          method: 'read',
          resource: 'settings',
        },
      },
      {
        sectionTitle: 'Lists & Images',
        route: '/assets',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: ['assets', 'settings'],
        },
        sub: [
          {
            heading: 'Governance',
            route: '/manage/assets/gov-editing',
            ability: {
              method: 'read',
              resource: 'assets',
            },
          },
          {
            heading: 'Areas',
            route: '/manage/assets/areas-listing',
            ability: {
              method: 'read',
              resource: 'assets',
            },
          },
          {
            heading: 'RE Sectors',
            route: '/manage/assets/sectors-listing',
            ability: {
              method: 'read',
              resource: 'assets',
            },
          },
          {
            heading: 'Badges',
            route: '/manage/assets/badges-listing',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Banners',
            route: '/manage/assets/banners-listing',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Influencers',
            route: '/manage/members/influencers-listing',
            svgIcon: '/media/icons/duotune/coding/cod010.svg',
            ability: {
              method: 'read',
              resource: 'users',
            },
          },
          {
            heading: 'Testimonials Management',
            route: '/manage/assets/testimonials-listing',
            svgIcon: '/media/icons/duotune/coding/cod010.svg',
            ability: {
              method: 'read',
              resource: 'indices',
            },
          },
        ],
      },
      {
        sectionTitle: 'Static Pages',
        route: '/settings',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: ['assets', 'settings'],
        },
        sub: [
          {
            heading: 'About Us (Mobile)',
            route: '/manage/settings/about-us-overview',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'About Us (Web)',
            route: '/manage/settings/about-us-overview-web',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Terms (Mobile)',
            route: '/manage/settings/terms-conditions-overview',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Terms (Web)',
            route: '/manage/settings/terms-conditions-overview-web',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'FAQs',
            route: '/manage/settings/faqs-listing',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Contact Us',
            route: '/manage/settings/contact-us-listing',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Header',
            route: '/manage/settings/header-section-listing',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Privacy (Mobile)',
            route: '/manage/settings/app-privacy-overview',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
          {
            heading: 'Privacy (Web)',
            route: '/manage/settings/app-privacy-overview-web',
            ability: {
              method: 'read',
              resource: 'settings',
            },
          },
        ],
      },
      {
        sectionTitle: 'Indices',
        route: '/indices',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'indices',
        },
        sub: [
          {
            heading: 'Date Range Setup',
            route: '/manage/assets/indices/date-range-setup-listing',
            ability: {
              method: 'read',
              resource: 'indices',
            },
          },
          {
            heading: 'Methodology',
            route: '/manage/assets/indices/methodology-listing',
            ability: {
              method: 'read',
              resource: 'indices',
            },
          },
          {
            heading: 'Property Categories',
            route: '/manage/assets/indices/property-categories-listing',
            ability: {
              method: 'read',
              resource: 'indices',
            },
          },
          {
            heading: 'Expert Review',
            route: '/manage/assets/indices/expert-review-listing',
            ability: {
              method: 'read',
              resource: 'indices',
            },
          },
          {
            heading: 'Rejection Reasons',
            route:
              '/manage/assets/indices/expert-review-reject-reasons-listing',
            ability: {
              method: 'read',
              resource: 'indices',
            },
          },
          {
            heading: 'Auto Sync Pipeline',
            route: '/manage/assets/indices/auto-sync',
            ability: {
              method: 'read',
              resource: 'indices',
            },
          },
        ],
      },
    ],
  },
  {
    heading: 'Content Management',
    route: '',
    ability: {
      method: 'read',
      resource: ['assets', 'settings'],
    },
    pages: [
      {
        heading: 'News',
        route: '/manage/assets/news-listing',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'assets',
        },
      },
      {
        sectionTitle: 'Newsletter',
        route: '/newsletter',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'newsletter',
        },
        sub: [
          {
            heading: 'Newsletter Sections',
            route: '/manage/newsletter/newsletter-sections-listing',
            ability: {
              method: 'read',
              resource: 'newsletter',
            },
          },
          {
            heading: 'Newsletter Sender',
            route: '/manage/newsletter/newsletter-sender-preview',
            ability: {
              method: 'read',
              resource: 'newsletter',
            },
          },
          {
            heading: 'Subscribers',
            route: '/manage/newsletter/newsletter-subscribers-listing',
            ability: {
              method: 'read',
              resource: 'newsletter',
            },
          },
        ],
      },
      {
        sectionTitle: 'Blogs',
        route: '/blogs',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        fontIcon: 'bi-sticky',
        ability: {
          method: 'read',
          resource: 'blogs',
        },
        sub: [
          {
            heading: 'Blog Posts',
            route: '/manage/blogs/blogs-listing',
            ability: {
              method: 'read',
              resource: 'blogs',
            },
          },
          {
            heading: 'Blog Tags',
            route: '/manage/blogs/blog-tags-listing',
            ability: {
              method: 'read',
              resource: 'blogs',
            },
          },
          {
            heading: 'Blog Categories',
            route: '/manage/blogs/blog-categories-listing',
            ability: {
              method: 'read',
              resource: 'blogs',
            },
          },
        ],
      },
    ],
  },
  {
    heading: 'Notification',
    route: '',
    ability: {
      method: 'create',
      // TODO: switch to 'deeplink-notifications' once roles have it.
      resource: 'users',
    },
    pages: [
      {
        heading: 'Send Notification',
        route: '/manage/notifications/send',
        svgIcon: '/media/icons/duotune/communication/com004.svg',
        fontIcon: 'bi-bell',
        ability: {
          method: 'create',
          resource: 'users',
        },
      },
    ],
  },
  {
    heading: 'SEO Management',
    route: '',
    ability: {
      method: 'read',
      resource: ['settings'],
    },
    pages: [
      {
        heading: 'Meta Tags SEO',
        svgIcon: '/media/icons/duotune/coding/cod010.svg',
        fontIcon: 'bi-sticky',
        route: '/manage/seo/metatags-listing',
        ability: {
          method: 'read',
          resource: 'settings',
        },
      },
    ],
  },
];
export default DocMenuConfig;
